import React, { useState } from 'react';
import { changePassword, isAdmin } from '../../api';
import { errorMessage, Notice, NoticeBox, PageHead } from './shared';

const SettingsPage: React.FC = () => {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [notice, setNotice] = useState<Notice>(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (form.next !== form.confirm) {
      setNotice({ severity: 'error', text: 'New passwords do not match.' });
      return;
    }
    setNotice(null);
    setBusy(true);
    try {
      const result = await changePassword(form.current, form.next);
      setNotice({ severity: 'success', text: result.message });
      setForm({ current: '', next: '', confirm: '' });
    } catch (err) {
      setNotice({ severity: 'error', text: errorMessage(err, 'Could not change password.') });
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <PageHead title="Account Settings" subtitle="Your partner login." />
      {/* Change password always applies to the logged-in user, so in admin act-as mode it would change the admin's own password. */}
      {isAdmin() ? (
        <div className="pp-panel"><p className="pp-muted" style={{ margin: 0 }}>Account settings belong to the venue owner and aren't available in admin mode.</p></div>
      ) : (
        <form className="pp-panel" onSubmit={handleSubmit} style={{ maxWidth: 520 }}>
          <h3 style={{ marginTop: 0 }}>Change Password</h3>
          <div className="pp-narrow">
            <NoticeBox notice={notice} />
            <div className="pp-field">
              <label htmlFor="pw-current">Current Password</label>
              <input id="pw-current" type="password" className="pp-input" required autoComplete="current-password" value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} />
            </div>
            <div className="pp-field">
              <label htmlFor="pw-new">New Password</label>
              <input id="pw-new" type="password" className="pp-input" required minLength={8} autoComplete="new-password" value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} />
              <span className="pp-hint">At least 8 characters.</span>
            </div>
            <div className="pp-field">
              <label htmlFor="pw-confirm">Confirm New Password</label>
              <input id="pw-confirm" type="password" className="pp-input" required minLength={8} autoComplete="new-password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
            </div>
            <div><button type="submit" className="pp-btn pp-gold" disabled={busy}>{busy ? 'Saving...' : 'Change Password'}</button></div>
          </div>
        </form>
      )}
    </>
  );
};

export default SettingsPage;
